module.exports = __webpack_public_path__ + "img/BAU Seniors_Infographics_04.d056bbff.png";